export default {
    /**
     * Verifica se o pedido pode ser enviado
     * @param order
     * @return {boolean}
     */
    canShip(order) {
        console.log("Verificando se o pedido pode ser enviado...");
        if (order) {
            if (this.canUnhold(order) || this.isPaymentReview(order)) {
                console.log("Pedido em hold ou revisão de pagamento. canShip = false");
                return false;
            }
            if (order.is_virtual || this.isCanceled(order)) {
                console.log("Pedido virtual ou cancelado. canShip = false");
                return false;
            }
            if (this.canShipItem(order)) {
                console.log("Há itens para enviar. canShip = true");
                return true;
            }
        }
        console.log("Nenhuma condição atendida. canShip = false");
        return false;
    },

    /**
     * Verifica se há itens que podem ser enviados
     * @param order
     * @return {*}
     */
    canShipItem(order) {
        const OrderItemService = require("../../../../../service/sales/order/OrderItemService").default;

        const items = this.getAllItems(order);
        console.log("Itens do pedido:", items);

        const canShip = items.find(item => {
            const qtyToShip = OrderItemService.getQtyToShip(item, order);
            console.log(`Item ${item.sku}: qtyToShip = ${qtyToShip}`);
            return qtyToShip > 0 && !item.is_virtual;
        });

        console.log("canShipItem =", !!canShip);
        return canShip;
    },

    /**
     * Loga a quantidade a ser enviada de todos os itens do pedido
     * @param order
     */
    logQtyToShip(order) {
        if (!order || !order.items) {
            console.log("Pedido inválido ou sem itens.");
            return;
        }

        const OrderItemService = require("../../../../../service/sales/order/OrderItemService").default;

        order.items.forEach(item => {
            const qtyToShip = OrderItemService.getQtyToShip(item, order);
            console.log(`Item ${item.sku} (ID: ${item.item_id}): qtyToShip = ${qtyToShip}`);
        });
    }
};



// WEBPACK FOOTER //
// ./src/extension/take-shipment/mixin/service/sales/OrderServiceMixin.js